<div fxLayout="row" fxLayoutAlign="center center">
  <p>
    {{ (modelName || 'ct.select_calendar_office') | translate }}
  </p>
  <span fxFlex></span>
  <div>
    <button mat-raised-button (click)="selectOffice(field)"> {{ 'ct.select_office' | translate }} </button>
  </div>
</div>